<!-- cSpell:disable -->
<div class="contenedor" id="fondo-principal">
  <div>
      <div>
        <img src="/assets/images/logoNegos.svg" alt="Logo Negos" width="350px">
      </div>

      <p class="text-center">
        <asl-google-signin-button
          type="standard"
          locale="es"
          theme="filled_blue"
          text="signin_with"
          size="large"
          shape="pill"></asl-google-signin-button>
      </p>
      
      <p class="warning" *ngIf="isError">usuario sin permiso para acceder.</p>

      <p class="text-description">Usa tu cuenta de Google Enterprise LATAM para ingresar a NEGOS</p>
  </div>
</div>
